import React from "react";
import { Navigate } from "react-router-dom";

/**
 * The password reset flow now lives entirely on /forgot-password (OTP code).
 * Any legacy /reset-password?token=xxx links redirect here gracefully.
 */
export default function PortalResetPassword() {
  return <Navigate to="/forgot-password" replace />;
}
